<template>
  <div v-if="!submitted || Object.keys(itemsGrouped).length" class="row">
    <div class="col-12">
      <SectionTitle
        has-line
        content="Seleccione el material y/o equipo necesario para trabajar las destrezas"
      />
    </div>
    <div class="col-12">
      <div class="container-fluid bg-light-gray pb-2 border-radius--light">
        <template v-if="!showFormItems && !submitted">
          <ActionButton
            type="activationButton"
            text="Presione aquí para añadir materiales y/o equipos"
            :class="{ invalid: validate }"
            @click="active = true"
          />
        </template>
        <template v-else>
          <Form
            v-if="!submitted"
            :collections="collections"
            :articles-to-exclude="articlesToExclude"
            :saloon="saloon"
            @submit="add"
            @close="handleClose()"
          />
          <validation-observer ref="materialsQuantity">
            <template v-for="(materials, key) in itemsGrouped">
              <div :key="key" class="pt-2">
                <h5 class="font-weight-bold font-16 ml-1 color-gray-12">
                  {{ key }}
                </h5>
                <Item
                  v-for="(item, index) in materials"
                  :key="`item_${index}`"
                  :item="item"
                  :submitted="submitted"
                  @remove="remove"
                />
              </div>
            </template>
          </validation-observer>
        </template>
      </div>
      <error
        v-if="showMaterialsError"
        message="Seleccionar al menos un articulo."
        variant="no-border"
      />
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import ActionButton from 'ActionButton';
import Form from './components/Form';
import Item from './components/Item';
import groupBy from 'lodash/groupBy';
import Error from 'custom-error';
import alert from '@/mixin/alert.mixin';

export default {
  name: 'MaterialsEquipment',
  mixins: [alert],
  components: {
    SectionTitle,
    ActionButton,
    Form,
    Item,
    Error,
  },
  props: {
    materialsEquipment: { type: Array, default: () => [] },
    saloon: { type: Object, default: () => {} },
    submitted: { type: Boolean, default: false },
    validate: { type: Boolean, default: false },
  },
  data() {
    return {
      active: false,
      collections: {},
      showMaterialsError: false,
    };
  },
  computed: {
    hasAnyItems() {
      return this.materialsEquipment.length > 0;
    },
    showFormItems() {
      return this.hasAnyItems || this.active;
    },
    itemsGrouped() {
      return groupBy(this.materialsEquipment, function(item) {
        return item.category.name;
      });
    },
    articlesToExclude() {
      return this.materialsEquipment.map((x) => x.article.id);
    },
  },
  methods: {
    add(item, reset) {
      this.$emit('update:validate', false);
      if (this.submitted) {
        return;
      }
      this.materialsEquipment.push(item);
      this.showMaterialsError = false;
      reset();
    },
    remove(item) {
      if (this.submitted) {
        return;
      }
      const index = this.materialsEquipment.findIndex(
        (x) => x.article.id == item.article.id
      );
      this.materialsEquipment.splice(index, 1);
    },
    showRequiredMsg() {
      this.showMaterialsError = true;
    },
    showQtyErrorMsg() {
      return this.$refs.materialsQuantity?.validate() || true;
    },
    async handleClose() {
      if (this.materialsEquipment.length > 0) {
        let response = await this.ShowCancelModal(
          'Confirmación',
          'Usted cuenta con artículos documentados, ¿está seguro que desea eliminar los artículos?',
          'Sí',
          'No'
        );
        if (response) {
          this.materialsEquipment.splice(0, this.materialsEquipment.length);
        }
      }

      this.active = false;
    },
  },
};
</script>

<style scoped></style>
